import type { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

class UserClient {
	constructor(private axiosClient: AxiosInstance) {}

	private base = "/api/admin/user"

	public resetToDefaultPassword = (userId: string) =>
		handleQueryResult(
			this.axiosClient.post<void>(
				`${this.base}/${userId}/resetToDefaultPassword`
			)
		)

	public sendResetPasswordEmail = (userId: string) =>
		handleQueryResult(
			this.axiosClient.post<void>(
				`${this.base}/${userId}/sendResetPasswordEmail`
			)
		)
}

export default UserClient
